import { render, staticRenderFns } from "./UploadDocumentList.vue?vue&type=template&id=6be20e92&"
import script from "./UploadDocumentList.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports